import React from 'react';
import TagStationModal from '../../shared/component/tag/TagStationModal';
import TagStationModalMobile from '../../shared/component/tag/mobile/TagStationModalMobile';
import { useWorkTag } from '../../shared/hooks/useApi/useWorkTag';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';
import { canShowWorkTagList } from '../../shared/util/visibility/workTagVisibility';
import { useAuth } from '../../shared/hooks/useApi/useAuth';

interface WorkTagStationModalProps {
  isMobile: boolean;
  setIsUserInput: (isUserInput: boolean) => void;
}

const WorkTagStationModal: React.FC<WorkTagStationModalProps> = ({
  isMobile,
  setIsUserInput,
}) => {
  const pageOwner = usePageOwnerIdentityStore((s) => s.pageOwner);
  const { isOwner } = useAuth();
  const {
    tags,
    listOwnerAui,
    status,
    getWorkTagList,
    updateWorkTag,
    deleteWorkTag,
  } = useWorkTag();
  const canShowTags = canShowWorkTagList({
    pageOwnerAui: pageOwner?.aui,
    listOwnerAui,
    status,
  });
  const visibleTags = canShowTags ? tags : [];

  const modalProps = {
    tags: visibleTags,
    loadTags: getWorkTagList,
    loadKey: pageOwner?.aui ? `${pageOwner.aui}:${isOwner ? 'owner' : 'public'}` : null,
    updateTag: updateWorkTag,
    deleteTag: deleteWorkTag,
    setIsUserInput,
  };

  return isMobile
    ? <TagStationModalMobile {...modalProps} />
    : <TagStationModal {...modalProps} />;
};

export default WorkTagStationModal;
